import i18n from "@/services/i18n";
export default {
    doc_1: i18n.t('utilsData.tips.doc_1') ,
    doc_3: i18n.t('utilsData.tips.doc_3'),
    passport: i18n.t('utilsData.tips.passport'),
    passportCode: i18n.t('utilsData.tips.passportCode'),
    publicLink: i18n.t('utilsData.tips.publicLink')
};
